import axios from '../../../utills/axiosConfig';

export const fetchOrderTypes = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/order-types', { params });
  return res.data;
};

export const addOrderType = async (orderType) => {
  try {
    const res = await axios.post('/order-types', orderType);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateOrderType = async (id, orderType) => {
  const res = await axios.put(`/order-types/${id}`, orderType);
  return res.data;
};

export const deleteOrderType = async (id) => {
  const res = await axios.delete(`/order-types/${id}`);
  return res.data;
};

export const importOrderTypeCSV = async (formData) => {
  const { data } = await axios.post('/order-types/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 